import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-remove-access-dialog',
    templateUrl: './remove-access-dialog.component.html',
    styleUrls: ['./remove-access-dialog.component.css'],
    standalone: false,
})
export class RemoveAccessDialogComponent {
    constructor(private dialogRef: MatDialogRef<RemoveAccessDialogComponent>) {}

    remove() {
        this.dialogRef.close(true);
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
